"use client";

// packages/eden-block-quote/src/index.jsx
import { Fragment } from "react";
import styled from "styled-components";
import { spacing16, spacing8 } from "@churchofjesuschrist/eden-style-constants";
import { Text1, Text4 } from "@churchofjesuschrist/eden-text";
import { jsx, jsxs } from "react/jsx-runtime";
var halfSpacing = spacing8;
var Root = styled.blockquote`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: -${halfSpacing};
`;
var Text = styled.div`
  flex: 1 1 18rem;
  margin: ${halfSpacing};
`;
var Publication = styled.span`
  font-style: italic;
`;
var AvatarContainer = styled.div`
  margin: ${halfSpacing};
`;
var Citation = styled.footer`
  display: block;
  margin-block-start: ${spacing16};
  font-style: normal;
`;
var BlockQuote = ({
  avatar,
  author,
  title,
  cite,
  publication,
  date,
  page,
  note,
  children,
  ...props
}) => /* @__PURE__ */ jsxs(Root, { cite, ...props, children: [
  avatar ? /* @__PURE__ */ jsx(AvatarContainer, { children: avatar }) : null,
  /* @__PURE__ */ jsxs(Text, { children: [
    /* @__PURE__ */ jsx(Text1, { children }),
    (author || title || publication || date || page || note) && /* @__PURE__ */ jsx(Citation, { children: /* @__PURE__ */ jsx(Text4, { children: [
      author,
      title ? /* @__PURE__ */ jsx("cite", { children: title }) : null,
      publication ? /* @__PURE__ */ jsx(Publication, { children: publication }) : null,
      date,
      page,
      note
    ].filter(Boolean).map((item, i) => [
      i > 0 && ", ",
      /* @__PURE__ */ jsx(Fragment, { children: item }, i)
    ]) }) })
  ] })
] });
BlockQuote.displayName = "BlockQuote";
export {
  BlockQuote
};
